import { render, staticRenderFns } from "./TareasFrecuentes.vue?vue&type=template&id=13630a57&scoped=true"
import script from "./TareasFrecuentes.vue?vue&type=script&lang=js"
export * from "./TareasFrecuentes.vue?vue&type=script&lang=js"
import style0 from "./TareasFrecuentes.vue?vue&type=style&index=0&id=13630a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13630a57",
  null
  
)

export default component.exports